import React, { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { formatGs, LOCATION_NAMES } from "@/lib/format";
import { printHtml, zHtml } from "@/lib/print";
import { Btn } from "@/components/ui/kit";
import { DatePicker } from "@/components/DatePicker";
import { toast } from "sonner";
import { FileText, Printer, AlertTriangle } from "lucide-react";

const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Asuncion" });
const Line = ({ l, v, cls = "" }) => <div className="flex justify-between text-sm py-1"><span className="text-muted-foreground">{l}</span><span className={`font-data font-semibold ${cls}`}>{v}</span></div>;

export const ZReport = ({ location }) => {
  const [date, setDate] = useState(today());
  const [z, setZ] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    api.get("/reports/z", { params: { location, date } }).then((r) => setZ(r.data)).catch((e) => toast.error(apiErr(e)));
  }, [location, date]);

  const print = () => { if (z && !printHtml("Cierre Z", zHtml(z, settings))) toast.error("Permití ventanas emergentes para imprimir"); };
  const t = z?.totals;
  return (
    <div className="card-surface p-5 mt-6" data-testid="z-report">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <h3 className="font-head font-bold flex items-center gap-2 mr-auto"><FileText className="w-4 h-4 text-primary" /> Cierre Z diario · {LOCATION_NAMES[location]}</h3>
        <DatePicker value={date} onChange={(v) => setDate(v || today())} testId="z-date" />
        <Btn onClick={print} disabled={!z} data-testid="z-print"><Printer className="w-4 h-4" /> Imprimir Z</Btn>
      </div>
      {z && (
        <>
          {z.open_sessions > 0 && <div className="flex items-center gap-2 text-xs text-amber-500 border border-amber-500/40 rounded-lg px-3 py-2 mb-4" data-testid="z-open-warning"><AlertTriangle className="w-4 h-4" /> Hay {z.open_sessions} caja(s) aún abierta(s) este día</div>}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <p className="text-[10px] font-bold tracking-widest text-muted-foreground mb-1">VENTAS</p>
              <Line l="Cantidad" v={z.num_sales} />
              <Line l="Total vendido" v={<span data-testid="z-total-sales">{formatGs(z.total_sales)}</span>} cls="text-primary" />
              <Line l="Descuentos" v={formatGs(z.discounts)} />
            </div>
            <div>
              <p className="text-[10px] font-bold tracking-widest text-muted-foreground mb-1">FORMAS DE PAGO</p>
              <Line l="Efectivo (neto)" v={<span data-testid="z-efectivo">{formatGs(z.by_method.efectivo)}</span>} cls="text-emerald-500" />
              <Line l="Tarjeta (POS)" v={formatGs(z.by_method.tarjeta)} cls="text-blue-500" />
              <Line l="Transferencia" v={formatGs(z.by_method.transferencia)} cls="text-purple-500" />
              <Line l="Vuelto entregado" v={formatGs(z.change_given)} />
            </div>
            <div>
              <p className="text-[10px] font-bold tracking-widest text-muted-foreground mb-1">CAJA · {z.sessions.length} TURNOS</p>
              <Line l="Montos iniciales" v={formatGs(t.opening)} />
              <Line l="Retiros / Ajustes" v={`${t.retiros ? "-" : ""}${formatGs(t.retiros)} / ${formatGs(t.ajustes)}`} />
              <Line l="Esperado" v={formatGs(t.expected)} />
              <Line l="Contado" v={formatGs(t.counted)} />
              <Line l="Diferencia" v={<span data-testid="z-difference">{formatGs(t.difference)}</span>} cls={t.difference === 0 ? "text-emerald-500" : "text-red-500"} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
